import React from "react";
import { MESSAGE } from "../constants";

/**
 * Offline parcel loading for single-spa widgets is on hold; surface the standard
 * offline copy until that flow ships.
 */
export const OfflineWidgetWrapper: React.FC = () => (
  <div>{MESSAGE.network_error}</div>
);
